import store from '../../store/store';
import { getClientId } from 'owa-config';
import { getClientVersion } from 'owa-config';

const sessionId = store.sessionId;
const clientId = getClientId();
const clientVersion = getClientVersion();

export default function setOgmaHeaders(req: XMLHttpRequest, correlationId: string): boolean {
    if (correlationId && sessionId && clientId && clientVersion) {
        req.setRequestHeader('Content-type', 'application/json');
        req.setRequestHeader('Accept', 'application/json, text/plain, */*');
        req.setRequestHeader('x-translator-sid', sessionId);
        req.setRequestHeader('x-translator-cross-sid', sessionId);
        req.setRequestHeader('x-translator-cid', correlationId);
        // User ID is used in OGMA for throttling
        req.setRequestHeader('x-translator-user-id', clientId);
        req.setRequestHeader('x-translator-client-version', clientVersion);
        req.setRequestHeader('x-translator-client-app', 'Outlook');
        req.setRequestHeader('x-translator-client-type', 'Browser');

        return true;
    }
    return false;
}
